var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('v-btn',{staticClass:"ma-4",attrs:{"color":"primary"},on:{"click":function($event){_vm.runSearch += 1}}},[_vm._v("Run Searches")])],1),(_vm.myQueryConfig)?_c('test-query',{attrs:{"config":_vm.myQueryConfig,"run-search":_vm.runSearch}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }